import { render, staticRenderFns } from "./MoreBlock.vue?vue&type=template&id=37f36538&scoped=true"
import script from "./MoreBlock.vue?vue&type=script&lang=js"
export * from "./MoreBlock.vue?vue&type=script&lang=js"
import style0 from "./MoreBlock.vue?vue&type=style&index=0&id=37f36538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f36538",
  null
  
)

export default component.exports